import moment from 'moment';

export const updateCsLocale = ()  => {
  moment.updateLocale("cs", {
    months: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"]
  })
}